export const SEND_VERIFY_CODE = 'SEND_VERIFY_CODE';
export const SEND_VERIFY_CODE_SUCCESS = 'SEND_VERIFY_CODE_SUCCESS';
export const SEND_VERIFY_CODE_ERROR = 'SEND_VERIFY_CODE_ERROR';
export const SET_VERIFY_ITEM = 'SET_VERIFY_ITEM';

export const CONFIRM_VERIFY_CODE = 'CONFIRM_VERIFY_CODE';
export const CONFIRM_VERIFY_CODE_SUCCESS = 'CONFIRM_VERIFY_CODE_SUCCESS';
export const CONFIRM_VERIFY_CODE_ERROR = 'CONFIRM_VERIFY_CODE_ERROR';
export const CLEAR_CONFIRM_VERIFY_CODE_ERROR_DATA =
  'CLEAR_CONFIRM_VERIFY_CODE_ERROR_DATA';

export const CREATE_PATIENT_ACCOUNT = 'CREAT_PATIENT_ACCOUNT';
export const CREATE_PATIENT_ACCOUNT_SUCCESS = 'CREAT_PATIENT_ACCOUNT_SUCCESS';
export const CREATE_PATIENT_ACCOUNT_ERROR = 'CREAT_PATIENT_ACCOUNT_FAIL';

export const CREATE_PATIENT_INF = 'CREATE_PATIENT_INF';
export const CREATE_PATIENT_INF_SUCCESS = 'CREATE_PATIENT_INF_SUCCESS';
export const CREATE_PATIENT_INF_ERROR = 'CREATE_PATIENT_INF_ERROR';

export const LOAD_LIST_PATIENT_KIN = 'LOAD_LIST_PATIENT_KIN';
export const LOAD_LIST_PATIENT_KIN_SUCCESS = 'LOAD_LIST_PATIENT_KIN_SUCCESS';
export const LOAD_LIST_PATIENT_KIN_ERROR = 'LOAD_LIST_PATIENT_KIN_ERROR';

//create case
export const CREATE_CASE = 'CREATE_CASE';
export const CREATE_CASE_SUCCESS = 'CREATE_CASE_SUCCESS';
export const CREATE_CASE_ERROR = 'CREATE_CASE_ERROR';

export const RESET_LIST_PATIENT_KIN = 'RESET_LIST_PATIENT_KIN';
